// This file contains constants that are common to JS and TS files

export const SPONTANEOUS_APPLICATION_ID = '5080334003'
